// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"43ece1bb","239":"9cf7b3a2","557":"c491cfac","732":"6e529824","762":"634ac84d"}[chunkId] + ".chunk.js";
};